import { environment } from 'src/environment';
import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery';
import { LoggerService } from 'src/app/core/authentication/logger.service';
import { SettingsService, BaseService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { DatalayerService } from 'src/app/core/services/datalayer.service';
import { LanguageService } from 'src/app/core/services/language.service';
import { MyAccountService } from 'src/app/core/services/my-account.service';
import { ParentalControlService } from 'src/app/core/services/parental-control.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { ParentalControl } from 'src/app/shared/models';
import * as uikit from 'uikit'
import { ChangePlanComponent } from './model-screens/change-plan/change-plan.component';
import { ParentalControlComponent } from './model-screens/parental-control/parental-control.component';
import { ApplicationService } from 'src/app/core/services/application.service';
import { ModelPaymentComponent } from 'src/app/shared/components/model-payment/model-payment.component';
import { SessionService } from 'src/app/core/services/session.service';
import { RedeemVoucherScreenComponent } from './model-screens/redeem-voucher-screen/redeem-voucher-screen.component';
import { PlanService } from 'src/app/core/services/plan.service';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';

@Component({
  selector: 'app-main-account',
  templateUrl: './main-account.component.html',
  styleUrls: ['./main-account.component.scss', './main-account.component.scss']
})
export class MainAccountComponent implements OnInit, OnDestroy, AfterViewInit {

  // user data coming from response
  userData: any;
  // user name coming from response
  userName: any;
  // user email
  userEmail: any;
  // user picture
  userPicture: any;
  //user phone number
  userNumber: any;
  // user payment data
  userPaymentData: any;
  // variable to stire data from the response
  profile: any;
  // user_login_by coming from response
  userLoginBy: any;
  //userId
  userId: string;
  account: boolean;
  device: string;
  //for change subcription component
  discountFlag = false;
  // Mt account  data coming from response
  myAccountData: any;
  updatePaymentData: any;
  userTelco: any;
  homeImage: any;
  locales: any;
  subscriptions: any;
  subscribedPlan: any;
  subscribedPlanId: any;
  stripeSubscriptionId: any;
  subscriptionTitle: any;
  subscriptionAmount: any;
  parentalControl: ParentalControl;
  updateBillingData: boolean;
  userIntegrationType;
  userType;
  closeEdit = false;
  @ViewChild('ChangePlan', {static: false}) changePlanComponent: ChangePlanComponent;
  @ViewChild('ParentalPin', {static: false}) parentalPinComponent: ParentalControlComponent;
  @ViewChild('ModelPayment', {static: false}) ModelPaymentComponent: ModelPaymentComponent;
  @ViewChild('RedeemVoucher', {static: false}) RedeemVoucherScreenComponent: RedeemVoucherScreenComponent;
  ageLimitTitle = '';
  toptext;
  bottomText;
  phoneCodes: any;
  selectedPhoneCodeObj: any;
  userPhoneCodeObj: any;
  plansLength = 0;
  localeLength: any;
  openModelName;
  planData;
  userDataChild;
  hideDevice = true;

  paymentMethods: any;
  userSubscription: any;
  isVoucherSuspended: any;
  profileInfo: any;
  imagePath: any;
  skinName = environment.skinName;
  enableProfiles = false;
  constructor(public settingsService: SettingsService, private accountService: MyAccountService, private router: Router,
              private loggerService: LoggerService, private baseService: BaseService,private languageService: LanguageService,
              private subscriptionService: SubscriptionService, public configService: ConfigurationService,
              private parentalService: ParentalControlService, private storageService: StorageService,public planService:PlanService,
              private analyticsService: InhouseAnalyticsService, private appService: ApplicationService, private route: ActivatedRoute
              ) {
    this.locales = this.languageService.appLanguage;
    this.baseService.loaderSource.next(true);
    this.imagePath = this.settingsService.imagePath;
    if (this.settingsService.maxUserProfiles) this.enableProfiles = true;
    else this.enableProfiles = false;
    if(settingsService?.loginWithMobileEnabled) this.userPhoneCodeObj = this.appService?.getUserPhoneCodeObj();
  }

  ngOnInit(): void {
      const eventObj = {
        event_type: 'Page View',
        event_name: 'Account Page View',
        event_status: 'Success',
      };
      this.analyticsService.trackUserActions(eventObj);

      this.updateAllData();
      if(this.storageService.getLocalStore('ideal_pay_success')){
        this.toptext = '';
        this.bottomText=this.configService.localeKeys?.["account.voucher_assigned.text"];
        setTimeout(()=>document.getElementById('ideal_pay_success_btn').click(), 100); 
      }
      if(this.storageService.getLocalStore('ideal_update_success')) {
        this.toptext=this.configService.localeKeys?.["plans.payment_updated.text"];
        this.bottomText=this.configService.localeKeys?.["plans.payment_automatically_processed.text"];
        setTimeout(()=>document.getElementById('ideal_pay_success_btn').click(), 100);
      }
  }

  updateAfterCancel(){
    if(!this.settingsService.churnPreventionFlowEnabled) this.updateAllData();
  }

  updateDataAfterChild(evt: string) {
    if(evt === 'cancel'){
      this.changePlanComponent.subscription_index();
    }
    if(evt == 'redeem')
      this.updateBillingData = !this.updateBillingData;
    
    this.updateAllData();
  }


  updateAllData(){
    this.getAccount();
    if(this.planService.plansLength>0)this.getSubscriptionData();
  }

  showDevice(){
    this.hideDevice = false
  }

  activeTvRoute(){
    this.router.navigateByUrl('account/authenticate');
  }

  getSubscriptionData(){
    this.subscriptions = [];
    this.subscriptionService.userPlan().subscribe((data) => {
      if (data) {
        this.planData = data;
        this.subscriptions = data.plans;
        if (data?.plans) this.plansLength = data?.plans?.length;
        if (data.subscribed_plan_id) {
          this.subscribedPlanId = data?.subscribed_plan_id;
          this.stripeSubscriptionId = data?.stripe_subscription_id;
          if (this.subscribedPlanId) this.subscribedPlan = this.subscriptions.find(plan => plan?.subscription_id == this.subscribedPlanId);
          this.baseService.loaderSource.next(false);
        }
      }
    }, (error) => {
      this.baseService.loaderSource.next(false);
    });

  }

  getAccountEventReciever() {
    this.getAccount();
  }

  getAccount() {
    this.baseService.loaderSource.next(true);
    this.accountService.getAccountDetails().subscribe({
      next: res => {
        this.userDataChild = res;
        this.myAccountData = res;
        this.getProfileInfo();
        this.loggerService.isVoucherSuspended = this.isVoucherSuspended = this.myAccountData?.voucher?.is_voucher_suspended;
        this.subscriptionService.userType = this.userSubscription = this.myAccountData?.user_type;
        this.loggerService.userTelco = this.myAccountData?.user_telco;
      }, complete: () => {
        if (this.myAccountData.user_picture && (this.myAccountData.user_picture.indexOf('http://') === 0 || this.myAccountData.user_picture.indexOf('https://') === 0)) {
          this.userPicture = this.myAccountData.user_picture;
        } else {
          this.userPicture = this.settingsService.imagePath + this.myAccountData.user_picture;
        }
        this.userId = this.myAccountData.user_id;
        this.userName = this.myAccountData.user_name;
        this.userEmail = this.myAccountData.user_email;
        this.userLoginBy = this.myAccountData.user_login_by;
        this.userTelco = this.myAccountData.user_telco;
        this.userNumber = this.myAccountData.user_mobile == 'null' ? '' : this.myAccountData.user_mobile;
        this.userPaymentData = this.myAccountData.payment_method;
        this.storageService.setLocalStore('voucherInfo', this.userPaymentData.payment_info_text);
        this.subscriptionTitle = this.userPaymentData.subscription_title;
        this.subscriptionAmount = this.userPaymentData.subscription_amount;
        this.userType = this.myAccountData.user_type;
        this.userIntegrationType = this.myAccountData.user_integration_type;
        if(this.settingsService.parentalControlModuleEnabled){
          this.parentalControl = {
            is_parental_control_enabled : this.myAccountData.is_parental_control_enabled, // possible values (1 or 0)
            is_pin_already_set : this.myAccountData.is_pin_already_set, // possible values (1 or 0)
            set_age_limit : this.myAccountData.set_age_limit , // possible values (blank, 18, 13 or any number)
            age_limits : this.myAccountData.age_limits
          }
          if(this.parentalControl.is_pin_already_set) this.ageLimitTitle = this.parentalControl.age_limits.find((age)=> Number(age.value) === this.parentalControl.set_age_limit).title;
          this.pinCloseControl();
        }
        this.baseService.loaderSource.next(false);
      }
    });
  }

  pinCloseControl(){
    if(this.settingsService.parentalControlModuleEnabled && !this.parentalControl.is_pin_already_set) this.parentalService.setLimitAge.next(0);
    else this.parentalService.setLimitAge.next(this.myAccountData.set_age_limit);
  }

  logout () {
    this.baseService.loaderSource.next(true);
    this.loggerService.logout();
  }

  ngAfterViewInit(): void {
    if(this.settingsService.parentalControlModuleEnabled && this.parentalControl.is_pin_already_set) {
      this.parentalPinComponent.selectedAgeLimit = this.parentalControl.age_limits.find(limit => limit.value == this.myAccountData.set_age_limit);
      this.parentalPinComponent.parentalControlForm.controls.age_limit_value.setValue(this.myAccountData.set_age_limit);
    }
    this.setAgeParentPin();
  }

  setAgeParentPin(){
    this.parentalPinComponent.parentalControlForm.controls.age_limit_value_index.valueChanges.subscribe(value => {
      this.parentalPinComponent.selectedAgeLimit = this.parentalControl.age_limits[value];
      this.parentalPinComponent.parentalControlForm.controls.age_limit_value.setValue(this.parentalPinComponent.selectedAgeLimit.value);
      setTimeout(() => {this.parentalPinComponent.activeBar.nativeElement.style.width = (((value+1)/(this.parentalPinComponent.ageListLength+1)) * 100) + '%'});
    })
  }

  destroyModal(modalId: string){
    this.openModelName = '';
    const modal = uikit.modal(modalId);
    if (modal) {
      modal.hide();
      modal.$destroy(true);
    }
  }

  churnRoute(){
    this.router.navigateByUrl('/churn/extension');
  }

  openUikitDialog(modelId){
    const eventObj = {
      event_type: 'event',
      event_name: `Popup Open - ${modelId}`,
      event_status: 'Success',
    };
    this.analyticsService.trackUserActions(eventObj);

    if(modelId === '#edit-account') this.appService.closeEditAccount.next(true);
    this.openModelName = modelId;
    if (modelId === '#change-subscription' || modelId === '#choose-subscription') {
      if (this.plansLength === 1) {
        this.subscriptionService.userPlan().subscribe((data) => {
          if (data) {
            const plan = data.plans[0];
            if (plan.type_of_plan === 'alliance_plan') {
              window.open(plan?.redirection_url, '_blank');
              return;
            } else {
              this.openPopUp(modelId);
            }
          }
        });
      } else {
        setTimeout(() => {
          this.openPopUp(modelId);
        }, 0)
      }
    } else {
      setTimeout(() => {
        this.openPopUp(modelId);
      }, 0)
    } 
  }

  openPopUp(modelId) {
    $(modelId).addClass('uk-open').show();
    this.clearSelectedPaymentOptions();
    if('#parental-control-modal' === modelId){
      this.parentalPinComponent.parentalControl.age_limits = this.parentalPinComponent.parentalControl.age_limits.map((age)=> {
        if(Number(age.value) === this.parentalControl.set_age_limit) age.checked = true;
        else age.checked = false;
        return age
      });
    }
    //SPI-I897 When user navigate to My Account, Payment Category GA Event is triggering
    this.changePlanComponent.viewPlanGTM(this.changePlanComponent.selectedPlan);
  }

  close_ideal_pay_model(){
    this.storageService.removeLocalStore('ideal_pay_redirect');
    this.storageService.removeLocalStore('ideal_pay_success');
    this.storageService.removeLocalStore('ideal_update_success');
    this.destroyModal('#ideal_pay_redirect_model');
  }

  updateMethod() {
    this.subscriptionService.updateMethodApi().subscribe((data) => {
      if (data) {
        const session_id = data.session_id;
        const queryParams = { session_id };
        this.router.navigate(['/payment/update/info'], { queryParams })
      }
    });
  }

  clearSelectedPaymentOptions() {
    if (this.changePlanComponent) {
      this.changePlanComponent.step = 1;
      this.changePlanComponent.freePlanStep = 0;
      this.changePlanComponent.selectedPlan = {};
      this.changePlanComponent.displayProratedData = false;
    }
    if (this.ModelPaymentComponent) this.ModelPaymentComponent.ngOnInit();
    if (this.RedeemVoucherScreenComponent) this.RedeemVoucherScreenComponent.step = 1;
  }

  /* Function to update the data when cancel button is clicked payment success popup */
  onPaymentPopUpClose() { // Plese check for same function in oter components series video, live video and single video
    this.openModelName = '';
    if ((this.ModelPaymentComponent && this.ModelPaymentComponent?.step === 4) || (this.changePlanComponent && (this.changePlanComponent.step === 3 || this.changePlanComponent.freePlanStep === 4))) {
      if (this.changePlanComponent) this.changePlanComponent.subscription_index();
      this.updateDataAfterChild('redeem');
    }
  }

  navigateToBillingHistory() {
    this.router.navigate(['/account/billing-history']);
    this.baseService.loaderSource.next(true);

  }

  ngOnDestroy(){
    try{
      this.storageService.removeLocalStore('ideal_pay_redirect');
      this.storageService.removeLocalStore('ideal_pay_success');
      this.storageService.removeLocalStore('ideal_update_success');
      this.destroyModal('#change-password');
      this.destroyModal('#ideal_pay_redirect_model');
      this.destroyModal('#parental-control-modal')
      this.destroyModal('#change-language');
      this.destroyModal('#activate-tv-modal');
      this.destroyModal('#manage-devices');
      this.destroyModal('#feedback-screen');
      this.destroyModal('#billing-history');
      this.destroyModal('#change-subscription');
      this.destroyModal('#change-payment-info');
      this.destroyModal('#edit-account');
      this.destroyModal('#redeem-voucher-screen');
    }catch(err){
      console.log(err);
    }
  }
  closeEditAlso(){
    this.appService.closeDeviceEdit.next(true);
  }

  getProfileInfo() {
    const profileId = this.storageService.getSessionStore('profileId');
    this.profileInfo = this.myAccountData.profiles.find(item => { return item.profile_id === profileId });
  }

  switchToAnotherProfile() {
    sessionStorage.removeItem('profileId');
    this.loggerService.editMode.next(false);
    this.storageService.setLocalStore('targetUrl', location.href);
    this.router.navigateByUrl('/auth/user-profiles');
  }

  manageProfile() {
    this.router.navigateByUrl('/auth/user-profiles');
    this.loggerService.editMode.next(true);
  }
}
